import { render, staticRenderFns } from "./zyzs.vue?vue&type=template&id=0e8a2f40&scoped=true&"
import script from "./zyzs.vue?vue&type=script&lang=js&"
export * from "./zyzs.vue?vue&type=script&lang=js&"
import style0 from "./zyzs.vue?vue&type=style&index=0&id=0e8a2f40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a2f40",
  null
  
)

export default component.exports